// extracted by mini-css-extract-plugin
export default {"dots":"Loading_dots__lRtLV","loading-dots":"Loading_loading-dots__N0bD5"};